<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container-fluid">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Prijzen</h1>
        </div>
        <div class="controls">
            @if (!loading() && fcCustomerAreas().value?.length > 0) {
                <div
                    (click)="indexation()"
                    [class.disabled]="lockedInspectionSelected()"
                    class="fab small"
                    id="btn-indexation"
                    matTooltip="Prijzen indexeren"
                    matTooltipPosition="below">
                    <i class="fas fa-cash-register"></i>
                </div>
            }
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/management">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div class="row">
        @if (customerAreas()) {
            <ng-select
                [clearSearchOnAdd]="true"
                [closeOnSelect]="false"
                [disabled]="saving()"
                [formControl]="fcCustomerAreas()"
                [hideSelected]="true"
                [items]="customerAreas()"
                [multiple]="true"
                bindLabel="name"
                bindValue="id"
                class="col-md-6"
                id="customerareas"
                placeholder="Toon prijzen van">
            </ng-select>
        }
        @if (customerAreas()) {
            <ng-select
                [clearSearchOnAdd]="true"
                [closeOnSelect]="false"
                [formControl]="fcInspections()"
                [hideSelected]="true"
                [items]="inspections()"
                [multiple]="true"
                bindLabel="name"
                bindValue="id"
                class="col-md-6"
                placeholder="Toon prijzen van">
                <ng-template let-item="item" ng-label-tmp ng-option-tmp>
                    @if (item.lock) {
                        <i class="fa-duotone fa-lock me-1"></i>
                    } <small>{{item?.customer_area?.name}}</small> {{item.name}}
                </ng-template>
            </ng-select>
        }
    </div>
    <div class="row">
        <div class="col-auto">
            <mat-checkbox [formControl]="fcOnlyActiveItems()">Alleen gebruikte prijzen</mat-checkbox>
        </div>
        <div class="col">

        </div>
        <div class="col-auto">
            @if (fcOnlyActiveItems().value) {
                <button (click)="openAll()" mat-icon-button matTooltip="Alles uitklappen">
                    <i class="fa-solid fa-chevrons-down"></i>
                </button>
            }
        </div>
    </div>
    @if (loading() && fcInspections().value?.length > 0) {
        <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
    }
    @if (!loading() && fcInspections().value?.length > 0) {
        <mat-accordion [multi]="fcOnlyActiveItems().value" class="price-groups">
            @for (priceGroup of priceItems(); track priceGroup.group; let i = $index) {
                <mat-expansion-panel #panel id="panel-{{i}}">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{priceGroup.group}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <app-prices-edit
                        [extraCostNames]="extraCostNames()"
                        [inspections]="selectedInspections()"
                        [paintColorKeyVal]="paintColorKeyVal()"
                        [panelIndex]="i"
                        [panel]="panel"
                        [priceGroup]="priceGroup">
                    </app-prices-edit>
                </mat-expansion-panel>
            }
        </mat-accordion>
    }
    <div class="controls-bottom">
        @if (AuthorisationService.hasFeature('pricesSave')) {
            <div (click)="save()" [class.disabled]="saving() || loading()" class="fab big primary"
                 id="btn-Save">
                @if (!saving()) {
                    <i class="fas fa-save"></i>
                }
                @if (saving()) {
                    <i class="fas fa-circle-notch fa-spin"></i>
                }
            </div>
        }
    </div>
</div>
